<div *transloco="let t; read: 'shared.calculations.excludedCalculations'">
  <button
    mat-icon-button
    (click)="onOpen()"
    [matTooltip]="t('title')"
    matTooltipPosition="above"
  >
    <mat-icon class="text-icon-warning">warning</mat-icon>
  </button>
</div>
